var N = Object.defineProperty, h = Object.defineProperties;
var v = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var l = (t, s, o) => s in t ? N(t, s, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[s] = o, n = (t, s) => {
  for (var o in s || (s = {}))
    m.call(s, o) && l(t, o, s[o]);
  if (r)
    for (var o of r(s))
      p.call(s, o) && l(t, o, s[o]);
  return t;
}, u = (t, s) => h(t, v(s));
var y = (t, s) => {
  var o = {};
  for (var e in t)
    m.call(t, e) && s.indexOf(e) < 0 && (o[e] = t[e]);
  if (t != null && r)
    for (var e of r(t))
      s.indexOf(e) < 0 && p.call(t, e) && (o[e] = t[e]);
  return o;
};
import { jsx as P } from "react/jsx-runtime";
import "react";
import { u as g, B as j } from "./factory-ueRxoNOV.js";
import { u as F } from "./use-styles-DToiHEa6.js";
import { p as k } from "./polymorphic-factory-DufevJAl.js";
var i = { root: "m_87cf2631" };
const q = {
  __staticSelector: "UnstyledButton"
}, d = k(
  (t, s) => {
    const o = g("UnstyledButton", q, t), c = o, {
      className: e,
      component: a = "button",
      __staticSelector: f,
      unstyled: B,
      classNames: U,
      styles: _,
      style: b
    } = c, S = y(c, [
      "className",
      "component",
      "__staticSelector",
      "unstyled",
      "classNames",
      "styles",
      "style"
    ]), x = F({
      name: f,
      props: o,
      classes: i,
      className: e,
      style: b,
      classNames: U,
      styles: _,
      unstyled: B
    });
    return /* @__PURE__ */ P(
      j,
      n(u(n({}, x("root", { focusable: !0 })), {
        component: a,
        ref: s,
        type: a === "button" ? "button" : void 0
      }), S)
    );
  }
);
d.classes = i;
d.displayName = "@mantine/core/UnstyledButton";
export {
  d as U
};
